import { IPagination } from '@/types';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface IInitialState {
  pagination: IPagination & IRuleParamFilterKeys;
  searchInPagination: ISearchInPaginationKeys;
}

export type ISearchInPaginationKeys = {
  product?: string;
  country?: string;
  state?: string;
  collection?: string;
  vendor?: string;
  zipcode?: string;
};

export type IRuleParamFilterKeys = {
  name?: string;
  products?: string[];
  countries?: string[];
  states?: string[];
  collections?: string[];
  vendors?: string[];
  zipcodes?: string;
};

const initSearchInPagination: ISearchInPaginationKeys = {
  product: '',
  collection: '',
  vendor: '',
  country: '',
  state: '',
};

// Define the initial state using that type
const initialState: IInitialState = {
  pagination: {
    page: 1,
    perPage: 5,
    name: '',
    products: undefined,
    countries: undefined,
    states: undefined,
    collections: undefined,
    vendors: undefined,
    zipcodes: undefined,
  },
  searchInPagination: initSearchInPagination,
};

export const filterRulesSlice = createSlice({
  name: 'filterRules',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updatePagination: (state, action: PayloadAction<Partial<IPagination & IRuleParamFilterKeys>>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },

    updateSearchInPagination: (state, action: PayloadAction<ISearchInPaginationKeys>) => {
      state.searchInPagination = action.payload;
    },

    resetSearchInPagination: (state) => {
      state.searchInPagination = initSearchInPagination;
    },
  },
});

// Other code such as selectors can use the imported `RootState` type

export const paginationSelector = createSelector(
  (state: RootState) => state.filterRules.pagination,
  (pagination) => pagination,
);

export const searchInPaginationSelector = createSelector(
  (state: RootState) => state.filterRules.searchInPagination,
  (searchInPagination) => searchInPagination,
);

export default filterRulesSlice;
